var React = require('react');
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');
var classNames = require('classnames');

var Option = createReactClass({
	propTypes: {
		children: PropTypes.node,
		className: PropTypes.string,             // className (based on mouse position)
		isDisabled: PropTypes.bool,              // the option is disabled
		isFocused: PropTypes.bool,               // the option is focused
		isSelected: PropTypes.bool,              // the option is selected
		onFocus: PropTypes.func,                 // method to handle mouseEnter on option element
		onSelect: PropTypes.func,                // method to handle click on option element
		onUnfocus: PropTypes.func,               // method to handle mouseLeave on option element
		option: PropTypes.object.isRequired,     // object that is base for that option
		valueKey: PropTypes.string,
		labelKey: PropTypes.string,
	},

	blockEvent(event) {
		event.preventDefault();
		event.stopPropagation();
	},

	handleMouseDown (event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	},

	handleMouseEnter (event) {
		this.onFocus(event);
	},

	handleMouseMove (event) {
		this.onFocus(event);
	},

	onFocus (event) {
		if (!this.props.isFocused) {
			this.props.onFocus(this.props.option, event);
		}
	},

	render () {
		var option = this.props.option;
		var className = classNames(this.props.className, option.className);

		return option.disabled ? (
			<div 
				className={className}
				onMouseDown={this.blockEvent}
				onClick={this.blockEvent}>
				{this.props.label}
			</div>
		) : (
			<div className={className}
				style={option.style}
				onMouseDown={this.handleMouseDown}
				onMouseEnter={this.handleMouseEnter}
				onMouseMove={this.handleMouseMove}
				title={option.title}>
	
				<label onClick={this.blockEvent}>
					<input 
						   type="checkbox"
						   onChange={this.blockEvent}
						   name={this.props.checkboxName}
						   value={option[this.props.valueKey]}
						   checked={this.props.isSelected}
						   key={option.key}
						   className="multiselect-option-checkbox" />
					{option[this.props.labelKey]}
				</label>
			</div>
		);
	}
});

module.exports = Option;